/* unplugin-vue-components disabled */import { _PopupComponent as __unplugin_components_0 } from '@varlet/ui';import '@varlet/ui/es/popup/style/index.mjs';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/code07.png';
var _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  "class": "p-30px rd-10px bg-white"
}, [/*#__PURE__*/_createElementVNode("div", {
  "class": "text-center font-size-20px"
}, [/*#__PURE__*/_createElementVNode("span", {
  "class": "color-#397bfe mr-15px"
}, "咨询热线"), /*#__PURE__*/_createElementVNode("span", null, "15732052829")]), /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  "class": "mt-30px"
})], -1);
export default {
  __name: 'contactMethod',
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose;
    var show = shallowRef(false);
    var showCode = function showCode() {
      show.value = true;
    };
    __expose({
      open: showCode
    });
    return function (_ctx, _cache) {
      var _component_var_popup = __unplugin_components_0;
      return _openBlock(), _createBlock(_component_var_popup, {
        position: "center",
        "default-style": "",
        show: _unref(show),
        "onUpdate:show": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(show) ? show.value = $event : null;
        })
      }, {
        "default": _withCtx(function () {
          return [_hoisted_1];
        }),
        _: 1
      }, 8, ["show"]);
    };
  }
};